import { createContext, PropsWithChildren, useContext } from 'react';

/**
 * When enabled, table rows render with the optimized DOM structure:
 * a single cell wrapper, a flattened `BaseCell`, and single-cell CSS-only
 * skeleton loading rows.
 *
 * Defaults to `false` so every other table keeps the pre-optimization
 * behavior. Gated by `Feature.FrontendPerformanceRowRenderOptimization`.
 */
const RowRenderOptimizationContext = createContext(false);

export const RowRenderOptimizationProvider = ({
  enabled,
  children,
}: PropsWithChildren<{ enabled: boolean }>) => (
  <RowRenderOptimizationContext.Provider value={enabled}>
    {children}
  </RowRenderOptimizationContext.Provider>
);

export const useRowRenderOptimization = () =>
  useContext(RowRenderOptimizationContext);
